import { Injectable } from '@angular/core';
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private handlers: { [key: string]: DetachedRouteHandle } = {};

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (!route.routeConfig || route.routeConfig.loadChildren) {
      return false;
    }

    let shouldReuse = false;

    if (route.routeConfig.data) {
      route.routeConfig.data['reuse'] ? (shouldReuse = true) : (shouldReuse = false);
    }

    return shouldReuse;
  }

  store(route: ActivatedRouteSnapshot, handler: DetachedRouteHandle): void {
    if (handler && route.routeConfig) {
      this.handlers[route.routeConfig.path!] = handler;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig ? !!this.handlers[route.routeConfig.path!] : false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (!route.routeConfig || route.routeConfig.loadChildren) {
      return null;
    }

    return route.routeConfig ? this.handlers[route.routeConfig.path!] : null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
    let reUseUrl = undefined;

    if (future?.routeConfig?.data) {
      reUseUrl = future.routeConfig.data['reuse'];
    }

    const defaultReuse = future.routeConfig === current.routeConfig;
    const reuse = reUseUrl ?? defaultReuse;
    return reuse;
  }
}
